import React from 'react';
import { useStore } from '../../../../store';
import { useParams } from 'react-router-dom';
import TrainingAnimation from '../../components/TrainingAnimation';
import multiplayerIcon from './../../../../../../assets/2025/multiplayerIcon.png';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const paragraphsSettings = settings?.paragraphs[0];

  const param = useParams();
  const p_course = param.course || 'general-staff';
  const p_topic = param['*'] || 'welcome';
  const { getParagraphState, setParagraphState } = useStore();
  const paragraphs = getParagraphState(p_course, p_topic);
  // React.useEffect(() => {
  //
  // }, [paragraphs, setParagraphState]);
  const onCompleted = () => {
    paragraphs[0].state = 'completed';
    setParagraphState(p_course, p_topic, paragraphs);
  };
  return (
    <div className="topic-section-0">
      <div className="topic-section-0-left">
        <img className="multiplayerIcon" src={multiplayerIcon} alt="" />
        {/*<h1 className="header">{paragraphsSettings?.subTitle}</h1>*/}
        <div className="title">
          {settings?.message}
          <span className="title-welcome">{settings?.welcome}</span>
        </div>
        <div
          className="description"
          dangerouslySetInnerHTML={{
            __html: paragraphsSettings?.description,
          }}
        />
      </div>
      <TrainingAnimation
        onCompleted={onCompleted}
        items={[
          {
            icon: 'Icon9',
            title: paragraphsSettings?.l1,
            content: [
              paragraphsSettings?.l5,
              paragraphsSettings?.l6,
              paragraphsSettings?.l7,
              paragraphsSettings?.l8,
              paragraphsSettings?.l9,
            ],
          },
          {
            icon: 'Icon10',
            title: paragraphsSettings?.l2,
            content: [
              paragraphsSettings?.l10,
              paragraphsSettings?.l11,
              paragraphsSettings?.l13,
            ],
          },
          {
            icon: 'Icon14',
            title: paragraphsSettings?.l3,
            content: [
              paragraphsSettings?.l14,
              paragraphsSettings?.l12,
              paragraphsSettings?.l15,
              paragraphsSettings?.l16,
            ],
          },
          {
            icon: 'Icon16',
            title: paragraphsSettings?.l4,
            content: [paragraphsSettings?.l17, paragraphsSettings?.l18],
          },
        ]}
      />
    </div>
  );
};
export default Section1;
